'use client';

import { useNavigate } from '@hooks/useNavigation';

import { Button } from '@components/Button';
import { Illustration, IllustrationWrapper } from '@components/Common/Illustration';
import { TextGroup } from '@components/TextGroups';

import { SuccessContainer, SuccessTextContainer } from './styles';

interface SuccessProps {
  header: string;
  paragraph: string;
  link: string;
  buttonLabel: string;
  illustrationSrc: string;
  registrationComplete?: boolean;
}

/**
 * A reusable success message component with illustration and action button.
 */
export const SuccessMessage = ({
  header,
  paragraph,
  link,
  buttonLabel,
  illustrationSrc,
  registrationComplete = false,
}: SuccessProps) => {
  const { goToPath } = useNavigate();

  const handleClick = () => {
    if (link) {
      goToPath(link);
    }
  };

  if (registrationComplete) {
    return (
      <SuccessContainer>
        <SuccessTextContainer>
          <TextGroup header={header} paragraph={paragraph} />
        </SuccessTextContainer>
        <IllustrationWrapper small>
          <Illustration priority fill src={illustrationSrc} alt={paragraph} />
        </IllustrationWrapper>
        <Button onClick={handleClick} label={buttonLabel} />
      </SuccessContainer>
    );
  }

  return (
    <SuccessContainer>
      <TextGroup header={header} paragraph={paragraph} />
      <IllustrationWrapper small>
        <Illustration priority fill src={illustrationSrc} alt={paragraph} />
      </IllustrationWrapper>
      <Button onClick={handleClick} label={buttonLabel} />
    </SuccessContainer>
  );
};
